import { render, staticRenderFns } from "./DefaultWithdrawInput.vue?vue&type=template&id=53a836fb&lang=pug&"
import script from "./DefaultWithdrawInput.vue?vue&type=script&lang=ts&"
export * from "./DefaultWithdrawInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports